import Vue from "vue/dist/vue.esm";
// オートのみ使用
import tanshouOdds from './odds_tables/tanshou_odds_table';
import fukushouOdds from './odds_tables/fukushou_odds_table';
// 競輪のみ使用
import niwakutanOdds from './odds_tables/niwakutan_odds_table';
import niwakufukuOdds from './odds_tables/niwakufuku_odds_table';

import nirentanOdds from './odds_tables/nirentan_odds_table';
import nirenfukuOdds from './odds_tables/nirenfuku_odds_table';
import sanrentanOdds from './odds_tables/sanrentan_odds_table';
import sanrenfukuOdds from './odds_tables/sanrenfuku_odds_table';
import wideOdds from './odds_tables/wide_odds_table';

// odds table用mixin
var oddsTableMixin = {
  props: ['voteInfo', 'gameType'],
  methods: {
    prefLabel: function() {
      if (gameType == chari.const.GAME_TYPE.keirin) {
        return '府県';
      } else {
        return 'LG';
      }
    },
    addOddsTableItems: function(obj, deme) {
      return false;
    }
  }
}

// 2連単オッズ表
var nirentanOddsTable = {
  extends: nirentanOdds.nirentanOddsTable,
  mixins: [oddsTableMixin]
}

// 2連複オッズ表
var nirenfukuOddsTable = {
  extends: nirenfukuOdds.nirenfukuOddsTable,
  mixins: [oddsTableMixin]
}

// 3連単オッズ表
var sanrentanOddsTable = {
  extends: sanrentanOdds.sanrentanOddsTable,
  mixins: [oddsTableMixin]
}

// 3連複オッズ表
var sanrenfukuOddsTable = {
  extends: sanrenfukuOdds.sanrenfukuOddsTable,
  mixins: [oddsTableMixin]
}

// ワイドオッズ表
var wideOddsTable = {
  extends: wideOdds.wideOddsTable,
  mixins: [oddsTableMixin]
}

if (gameType == chari.const.GAME_TYPE.keirin) {
  // 2枠単オッズ表
  var niwakutanOddsTable = {
    extends: niwakutanOdds.niwakutanOddsTable,
    mixins: [oddsTableMixin]
  }
  
  // 2枠複オッズ表
  var niwakufukuOddsTable = {
    extends: niwakufukuOdds.niwakufukuOddsTable,
    mixins: [oddsTableMixin]
  }
  
  var bet_types = {
    'nirentan': chari.const.KEIRIN_BET_TYPE_LABEL.nirentan,
    'nirenfuku': chari.const.KEIRIN_BET_TYPE_LABEL.nirenfuku,
    'sanrentan': chari.const.KEIRIN_BET_TYPE_LABEL.sanrentan,
    'sanrenfuku': chari.const.KEIRIN_BET_TYPE_LABEL.sanrenfuku,
    'niwakutan': chari.const.KEIRIN_BET_TYPE_LABEL.niwakutan,
    'niwakufuku': chari.const.KEIRIN_BET_TYPE_LABEL.niwakufuku,
    'wide': chari.const.KEIRIN_BET_TYPE_LABEL.wide
  }
  
} else if (gameType == chari.const.GAME_TYPE.autorace) {
  // 単勝オッズ表
  var tanshouOddsTable = {
    extends: tanshouOdds.tanshouOddsTable,
    props: ['voteInfo'],
    methods: {
      addOddsTableItems: function(obj, deme) {
        return false;
      }
    }
  }

  // 複勝オッズ表
  var fukushouOddsTable = {
    extends: fukushouOdds.fukushouOddsTable,
    props: ['voteInfo'],
    methods: {
      addOddsTableItems: function(obj, deme) {
        return false;
      }
    }
  }

  var bet_types = {
    'nirentan': chari.const.AUTO_BET_TYPE_LABEL.nirentan,
    'nirenfuku': chari.const.AUTO_BET_TYPE_LABEL.nirenfuku,
    'sanrentan': chari.const.AUTO_BET_TYPE_LABEL.sanrentan,
    'sanrenfuku': chari.const.AUTO_BET_TYPE_LABEL.sanrenfuku,
    'tanshou': chari.const.AUTO_BET_TYPE_LABEL.tanshou,
    'fukushou': chari.const.AUTO_BET_TYPE_LABEL.fukushou,
    'wide': chari.const.AUTO_BET_TYPE_LABEL.wide
  }
}

const vm = new Vue({
  el: '#app',
  data: {
    gameType: gameType,
    open_day: open_day,
    vel_code: vel_code,
    race_num: race_num,
    raceInfo: {},
    vel_menu: {},
    voteInfo: {
      oddsTableData: {}
    },
    selectedBetType: '',
    bet_types: bet_types,
    end_of_sale_question: true,
    isLoaded: false
  },
  components: {
    'wideOddsTable': wideOddsTable,
    'sanrentanOddsTable': sanrentanOddsTable,
    'sanrenfukuOddsTable': sanrenfukuOddsTable,
    'nirentanOddsTable': nirentanOddsTable,
    'nirenfukuOddsTable': nirenfukuOddsTable,
    'niwakutanOddsTable': niwakutanOddsTable,
    'niwakufukuOddsTable': niwakufukuOddsTable,
    'tanshouOddsTable': tanshouOddsTable,
    'fukushouOddsTable': fukushouOddsTable
  },
  methods: {
    // 選手の情報なども含まれる
    fetchRaceInfo: function() {
      var url;
      if (this.gameType == chari.const.GAME_TYPE.keirin) {
        url = '/api/keirin/race_info';
      } else {
        url = '/api/auto/race_info';
      }
      
      $.ajax({
        url: url,
        dataType: 'json',
        data:{
          "open_day": this.open_day,
          "vel_code": this.vel_code,
          "race_num": this.race_num
        }
      }).done(function(res) {
        this.raceInfo = res;
        this.end_of_sale_question = res.box.end_of_sale_question;
        this.voteInfo.entries = res.race_athletes;
        this.fetchOddsPerRace();
      }.bind(this));
    },
    // fetch vel menu
    fetchVelMenu() {
      var url;
      if (this.gameType == chari.const.GAME_TYPE.keirin) {
        url = '/api/keirin/vel_menu';
      } else {
        url = '/api/auto/vel_menu';
      }
      
      $.ajax({
        url: url,
        dataType: 'json',
        data:{
          "vel_code": this.vel_code,
          "race_num": this.race_num,
          "open_day": this.open_day
        }
      }).done(function(res) {
        this.velMenu = res;
        
        this.fetchRaceInfo();
      }.bind(this));
    },
    fetchOddsPerRace: function() {
      this.isLoaded = false;
      
      var url;
      if (this.gameType == chari.const.GAME_TYPE.keirin) {
        url = '/api/keirin/odds_per_race';
      } else {
        url = '/api/auto/odds_per_race';
      }
      
      $.ajax({
        url: url,
        contentType:'application/json',
        data: {
          'open_day': this.open_day,
          'vel_code': this.vel_code,
          'race_num': this.race_num
        }
      }).done(function(data) {
        this.geneOddsTable(data);
        
        this.isLoaded = true;
      }.bind(this));
    },
    geneOddsTable: function(data) {
      var arr = data.odds;
      var active = this.selectedBetType;
      var temp = {};
      
      // deme を key としたmapに変換
      for (var i=0; i<arr.length; i++) {
        // TODO: 状態記録し記録があれば初期化しない
        if (arr[i].bet_type == active) {
          var item = arr[i];
          temp[item.deme] = {};
          temp[item.deme].isSelected = false;
          temp[item.deme].normalize_rate = item.normalize_rate;
          temp[item.deme].is_valid = item.is_valid;
        }
      }
      
      this.voteInfo.oddsTableData = temp;
      // vueにデータを変更検知させるため
      this.voteInfo = chari.util.deepCopy(this.voteInfo);
    },
    validIsLoaded: function() {
      this.isLoaded = true;
    },
    voteURL: function() {
      if (this.gameType == chari.const.GAME_TYPE.keirin) {
        return '/keirin/' + this.open_day + '/' + this.vel_code + '/?race_num=' + this.race_num;
      } else {
        return '/auto/' + this.open_day + '/' + this.vel_code + '/?race_num=' + this.race_num;
      }
    }
  },
  watch: {
    selectedBetType: function() {
      this.fetchOddsPerRace();
    }
  },
  created: function() {
    this.fetchVelMenu();
  },
  mounted: function() {
    var queryBetType = chari.util.getQueryStrings();
    var sessionKey = (gameType === 1) ? 'lastKeirinViewOddsType' : 'lastAutoViewOddsType';
    var lastViewType = sessionStorage.getItem(sessionKey);

    // NOTE: URL query > session > default
    this.selectedBetType = (queryBetType && Object.keys(this.bet_types).indexOf(queryBetType['bet_type']) > -1) ? queryBetType['bet_type'] : (lastViewType) ? lastViewType : 'nirentan';

    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem(sessionKey, this.selectedBetType);
    });
  }
})
